var centerChildren = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
export default centerChildren;